import React, { ReactNode } from 'react'

import { DrilldownCell, AddressCell, DateCell } from './SimpleTable'

import { MapLocation } from '../map/MapModal'

export function renderDrilldownCell(cell: DrilldownCell, onDrilldown: (cell: DrilldownCell) => void): ReactNode {
  if (cell.configuration) {
    return (
      <a
        id={cell.id}
        className={cell.className}
        href="#"
        onClick={(e) => {
          e.preventDefault()
          onDrilldown(cell)
        }}
      >
        <span className=" hover:underline text-blue-500">
          {typeof cell.value === 'boolean' ? `${cell.value}` : cell.value}
        </span>
      </a>
    )
  }
  return <span className={cell.className}>{typeof cell.value === 'boolean' ? `${cell.value}` : cell.value}</span>
}

export function renderAddressCell(cell: AddressCell, onMapClick: (location: MapLocation) => void): ReactNode {
  return (
    <a
      id={cell.id}
      className={`${cell.className || ''} text-blue-600 hover:text-blue-800 underline 
  cursor-pointer`}
      href="#"
      onClick={(e) => {
        e.preventDefault()
        onMapClick({
          ...cell,
          title: cell.address,
        })
      }}
    >
      <span>{cell.address}</span>
    </a>
  )
}

export function renderDateCell(cell: DateCell): ReactNode {
  return <span className={cell.className}>{cell.display}</span>
}

export function RenderCell(
  value: unknown,
  onDrilldown: (cell: DrilldownCell) => void,
  onMapClick: (location: MapLocation) => void
): ReactNode {
  if (value && typeof value === 'object' && 'display' in value && 'value' in value && !('configuration' in value)) {
    return (value as { display: ReactNode }).display
  }

  if ((value as DrilldownCell).value) {
    const cell = value as DrilldownCell
    return renderDrilldownCell(cell, onDrilldown)
  }

  if ((value as AddressCell).address) {
    const cell = value as AddressCell
    return renderAddressCell(cell, onMapClick)
  }

  if ((value as DateCell).date) {
    const cell = value as DateCell
    return renderDateCell(cell)
  }

  // Default rendering
  return typeof value === 'boolean' ? `${value}` : (value as ReactNode)
}
